// import _ from 'underscore';
import { useCallback } from 'react';
import { useFetch } from '@bingads-webui-campaign-react/campaign-http';

export const useBrandKitDataService = () => {
  const { post, put, del, response, cache, loading, error } = useFetch();
  // will fix loading, error, response, cache
  // const fetchData = useMemo(() => ({ response, cache, loading, error }), [response, cache, loading, error]);

  const getBrandKitDataByAccId = useCallback(
    ({ accId }: { accId: string }) => {
      const url = 'v13/BrandKits/QueryByAccountId';
      return post(url, { AccountId: accId });
    },
    [post]
  );

  const getBrandKitDataById = useCallback(
    ({ brandkitIds }: { brandkitIds: string[] }) => {
      const url = 'v13/BrandKits/QueryByIds';
      return post(url, { BrandKitIds: brandkitIds });
    },
    [post]
  );

  const createBrandKitData = useCallback(
    ({
      accId,
      brandKitData,
    }: {
      accId: string;
      brandKitData
    }) => {
      const url = 'v13/BrandKits';
      return post(url, { AccountId: accId, BrandKits: brandKitData });
    },
    [post]
  );

  const updateBrandKitData = useCallback(
    ({ accId, brandKitData }) => {
      const url = 'v13/BrandKits';
      return put(url, { AccountId: accId, BrandKits: brandKitData });
    },
    [put]
  );

  const deleteBrandKitData = useCallback(
    ({ brandKitIds, accId }: { brandKitIds: string[]; accId: string }) => {
      const url = 'v13/BrandKits';
      return del(url, { AccountId: accId, BrandKitIds: brandKitIds });
    },
    [del]
  );

  return {
    getBrandKitDataById,
    createBrandKitData,
    getBrandKitDataByAccId,
    updateBrandKitData,
    deleteBrandKitData,
    response,
    cache,
    loading,
    error,
  };
};
